import { Component } from '@angular/core';

import { DeleteAccountModal } from 'app/shared/modals/delete-account-modal/delete-account-modal';

@Component({
  selector: 'kh-teacher-delete-account-modal',
  styleUrls: ['./teacher-delete-account-modal.component.less'],
  templateUrl: './teacher-delete-account-modal.component.html',
  standalone: false
})
export class TeacherDeleteAccountModalComponent extends DeleteAccountModal {
}
